import React, { useState } from "react";
import "./AppoinmentForm.css";
import { useNavigate, useLocation } from "react-router-dom"; 
import backIcon from "../../Assets/Images/Expand_left.png";
import CalendarIcon from "../../Assets/Images/SVG/testlog-calendar.svg";

const AppoinmentForm = () => {
  const location = useLocation(); // Access the passed state data
  const { selectedDate, selectedSlot, reason, doctor } = location.state || {}; // Extract doctor and other data

  const [consultationReason, setConsultationReason] = useState(reason || ""); // Pre-fill with reason
  const [error, setError] = useState("");

  const navigate = useNavigate(); // Initialize useNavigate

  const handleConfirm = () => {
    if (!consultationReason.trim()) {
      setError("Reason for consultation is required.");
      return;
    }
    setError("");

      const isSuccess = true; 
    
      if (isSuccess) {
        navigate("/received");
      } else {
        navigate("/failure");
      }
    }

  const handleBackClick = () => {
    navigate(-1); // Navigate to the previous page
  };

  return (
    <div className="set-confirm-wrappers">
      <div className="sub-header">
        <button className="back-button" onClick={handleBackClick}>
          <img src={backIcon} alt="Back" className="back-icon" />
        </button>
        <h1 className="title-mydoctors">My Doctors</h1>
      </div>

      {/* Doctor Details Section */}
      {doctor && (
        <div className="set-confirm-doctor-section">
          <img
            src={doctor.image} // Display the selected doctor's image
            alt={doctor.name}
            className="set-confirm-doctor-image"
          />
          <div className="set-confirm-doctor-info">
            <h3 className="set-confirm-doctor-name">{doctor.name}</h3>
            <p className="set-confirm-doctor-qualification">
              {doctor.qualification}
            </p>
          </div>
        </div>
      )}

      <div className="set-confirm-form">
        <div className="set-confirm-form-group">
          <label className="set-confirm-label" htmlFor="date-input">
            Date
          </label>
          <div className="set-confirm-input-wrapper">
            <input
              type="text"
              id="date-input"
              className="set-confirm-input"
              value={selectedDate ? selectedDate.toLocaleDateString() : ""}
              readOnly
            />
            <img src={CalendarIcon} alt="Calendar" className="set-confirm-icon" />
          </div>
        </div>
        <div className="set-confirm-form-group">
          <label className="set-confirm-label" htmlFor="slot-time">
            Slot Time
          </label>
          <input
            type="text"
            id="slot-time"
            className="set-confirm-input"
            value={selectedSlot || ""}
            readOnly
          />
        </div>
        <div className="set-confirm-form-group">
          <label className="set-confirm-label" htmlFor="consultation-reason">
            Reason for Consultation <span className="mandatory">*</span>
          </label>
          <input
            type="text"
            id="consultation-reason"
            className={`set-confirm-input ${error ? "input-error" : ""}`}
            value={consultationReason}
            onChange={(e) => setConsultationReason(e.target.value)}
          />
        </div>
      </div>

      <div className="set-date-buttons">
        <button
          className="set-date-button set-date-back-button"
          onClick={handleBackClick}
        >
          Back
        </button>
        <button
          className="set-date-button set-date-next-button"
          onClick={handleConfirm}
        >
          Confirm
        </button>
      </div>
      {error && <p className="error-message">{error}</p>}
    </div>
  );
};

export default AppoinmentForm;
